// ReconModule.jsx - Main wrapper that exports the Recon Dashboard
// This file provides backward compatibility with existing imports

import React from 'react';
import { ReconDashboard } from './recon';

// Re-export ReconDashboard as the main component
export { ReconDashboard };

// Default export for backward compatibility
export default ReconDashboard;
